<template>
  <section class="document-form sme-container__info sme-container__info-document">
    <div class="box">
      <div class="table">
        <div class="th font-14" >Documents</div>
        <div
          v-if="formData.renewal_letter_insurer"
          class="form-item tr">
          <span>Renewal Letter（Insurer）</span>
          <file-container
            is-show-detail
            is-viewer
            :fileData="formData.renewal_letter_insurer" />
        </div>
        <div class="form-item tr">
          <span>Business Registration Certification</span>
          <file-container
            is-show-detail
            is-viewer
            :fileData="formData.id_type_pic" />
        </div>
        <div class="form-item tr">
          <span>Contract</span>
          <file-container
            is-show-detail
            is-viewer
            :fileData="formData.contract" />
        </div>
        <!--        <div-->
        <!--          v-if="formData.cust_typ == 2"-->
        <!--          class="form-item tr">-->
        <!--          <span>Business Registration Certificate</span>-->
        <!--          <file-container-->
        <!--            is-show-detail-->
        <!--            is-viewer-->
        <!--            :fileData="formData.br_pic" />-->
        <!--        </div>-->
        <div
          v-if="formData.other_file && formData.other_file.length > 0"
          class="form-item">
          <div class="tr">Additional Documents</div>
          <div class="tr form-item">
            <file-container
              v-for="(item, index) in formData.other_file"
              :key="index"
              :fileData="item"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'DecorationDocumentInfo',
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../quoting/sme/info";
.document-table{
  .tr:last-child{
    border-bottom-left-radius: 0px!important;
    border-bottom-right-radius: 0px!important;
  }
}

</style>
